export enum SearchSetting {
    MAX_SUGGESTIONS = 4,
    MAX_CHAR_COUNT = 350
}

export default SearchSetting;
